import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getToken } from '@grandvisionhq/auth';

const useAuthToken = ()=>{
    const [execute, setExecute] = React.useState(true);
    const [token, setToken] = React.useState(undefined);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(undefined);
    const refreshToken = React.useCallback(()=>setExecute(true)
    , []);
    React.useEffect(()=>{
        const execAsync = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                setExecute(false);
                setLoading(true);
                setError(undefined);
                try {
                    const result = yield getToken();
                    if (result === null || result === void 0 ? void 0 : result.length) {
                        setToken(result);
                    }
                } catch (e) {
                    if (e instanceof Error) {
                        setError(e);
                    } else {
                        const message = 'Unknown error while getting the auth token';
                        setError(new Error(message));
                        console.error(message, e);
                    }
                } finally{
                    setLoading(false);
                }
            });
            return function execAsync() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!execute) {
            return;
        }
        execAsync();
    }, [
        execute
    ]);
    return React.useMemo(()=>[
            {
                refreshToken
            },
            {
                loading,
                data: token,
                error
            }
        ]
    , [
        refreshToken,
        loading,
        token,
        error
    ]);
};

export { useAuthToken as default, useAuthToken };
//# sourceMappingURL=useAuthToken.js.map
